<section class="pt-0">
  <div class="logo-wrap px-4 py-4 w-full flex justify-content-center">
    <div>
      <h1>
        ESPECIALISTAS EN SEGUROS SUBACUÁTICOS <br />
        DESDE 2003
      </h1>
      <!-- <h2 class="subtitulo">
        Disfruta de la mejor experiencia en Consultores SegurSub
        <span class="stars">
          <img src="assets/img/stargris.svg" alt="Star" class="star" />
          <img src="assets/img/stargris.svg" alt="Star" class="star" />
          <img src="assets/img/stargris.svg" alt="Star" class="star" />
        </span>
      </h2> -->
    </div>
  </div>

  <div class="flex justify-content-end gap-4 align-items-end">
    <!-- <app-search-widget></app-search-widget> -->
  </div>
  <!--
  <p-carousel [value]="images">
    <ng-template pTemplate="item" let-image>
      <img [src]="image" style="width: 100%; display: block" alt="" />
    </ng-template>
  </p-carousel> -->

  <!-- <p-galleria
    [(value)]="images"
    [numVisible]="5"
    [circular]="true"
    [showItemNavigators]="true"
    [showThumbnails]="false"
    [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '640px' }">
    <ng-template pTemplate="item" let-item>
      <img [src]="item.itemImageSrc" style="width: 100%; display: block" />
    </ng-template>
  </p-galleria> -->
</section>
